import { cn } from "../../lib/utils";

/**
 * The user's chat message bubble — a right-aligned neutral chip whose bottom
 * corner tucks in towards the sender (Figma DS 5.0 "ChatMessageCard"). Shared by
 * the JuisciGPT and Chat-with-Paper surfaces, while streaming and once
 * finished, so the question renders identically throughout (no streaming-only
 * box-shadow). Callers add positioning (e.g. `mx-5`) via `className`.
 *
 * `desktop` is the desktop shell's bubble (Figma "user-bubble" of the desktop
 * mockups): 14px in slate-700 under 20px corners. `default` is the phone's,
 * 15px in slate-600 under 16px corners; the two differ on purpose and the
 * Figma component carries the note.
 */
export function ChatMessageCard({
  variant,
  children,
  className,
}: {
  variant: "default" | "desktop";
  children: React.ReactNode;
  className?: string;
}): React.JSX.Element {
  return (
    <div
      className={cn(
        // 480px wide from `md` (Figma "UX/UI Desktop Version", "user-bubble").
        "self-end max-w-75 md:max-w-120 bg-ds-black/4 px-4.5 py-3 font-dm-sans font-normal",
        variant === "desktop"
          ? "rounded-2xl rounded-br-sm text-sm tracking-ds text-ds-slate-700"
          : "rounded-2xl rounded-br-sm text-ui-body text-ds-slate-600",
        className
      )}
    >
      {children}
    </div>
  );
}
